export const arrayFlattener = (previous: Array<string>, current: Array<string>) => [...previous, ...current];
